module.exports = __webpack_public_path__ + "images/pages/for_business/pc/case4_20bd9521dd1adde749e3649d74a175df.png";